/* BCB header behaviour: mega panels and predictive search.

   Written against the markup the section already renders rather than building
   anything, so the navigation works before this file arrives and keeps working
   if it fails: every panel is real HTML with real links, and the search field is
   a plain GET form. This only upgrades both. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bcb-header]');
  if (!root) return;

  /* ---------------------------------------------------------------- panels */

  var scrim = document.querySelector('[data-bcb-scrim]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-bcb-panel-root]'));
  var openItem = null;
  var hoverTimer = null;

  function setHeaderHeight() {
    var rect = root.getBoundingClientRect();
    var height = Math.round(rect.height);
    if (height > 0) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }

    /* How many pixels of this header currently cover the top of the
       viewport. Sticky filters use this, not the full header height —
       otherwise a condensed or scrolled-away bar leaves a hole. */
    var cover = 0;
    if (rect.bottom > 0 && rect.top <= 0.5) {
      cover = Math.round(Math.min(rect.bottom, height));
    }
    document.documentElement.style.setProperty('--bcb-sticky-top', cover + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('theme:resize', setHeaderHeight);
  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(setHeaderHeight).observe(root);
  }

  var navToggle = root.querySelector('[data-bcb-nav-toggle]');
  function syncNavToggle() {
    if (!navToggle) return;
    navToggle.setAttribute('aria-expanded', root.classList.contains('is-nav-off') ? 'false' : 'true');
  }
  syncNavToggle();
  if (navToggle) {
    navToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var off = !root.classList.contains('is-nav-off');
      root.classList.toggle('is-nav-off', off);
      if (!off) root.classList.remove('is-condensed');
      try { localStorage.setItem('bcb-nav-open', off ? '0' : '1'); } catch (e) {}
      syncNavToggle();
      setHeaderHeight();
    });
  }

  /* Hover opens the panel on a real pointer, but not instantly: a shopper
     crossing the bar to reach the cart would otherwise flash three panels open
     on the way. Touch and keyboard always use an explicit activation. */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function triggerOf(item) {
    return item.querySelector('[data-bcb-panel-trigger]');
  }

  function panelOf(item) {
    var trigger = triggerOf(item);
    var id = trigger && trigger.getAttribute('aria-controls');
    if (id) {
      var byId = document.getElementById(id);
      if (byId) return byId;
    }
    return item.querySelector('[data-bcb-panel]');
  }

  function ownsEvent(item, node) {
    if (!node) return false;
    if (item.contains(node)) return true;
    var panel = panelOf(item);
    return !!(panel && panel.contains(node));
  }

  function isPhoneNav() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function close(item) {
    if (!item) return;
    var panel = panelOf(item);
    var trigger = triggerOf(item);
    if (panel) panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    item.dispatchEvent(new CustomEvent('bcb:panelclose'));
    if (openItem === item) openItem = null;
    if (!openItem && scrim) scrim.hidden = true;
    root.classList.toggle('has-open-panel', !!openItem);
  }

  function closeAll() {
    items.forEach(close);
  }

  function placePanel(item) {
    var panel = panelOf(item);
    if (!panel) return;
    var brands = item.hasAttribute('data-bcb-brands');
    var edge = brands
      ? root.querySelector('.bcb-header__bar')
      : root.querySelector('[data-bcb-nav]');
    if (!edge) edge = root;
    var top = edge.getBoundingClientRect().bottom;
    /* Brands sits in the sticky header, so its sheet is position:absolute
       against that box. Viewport `top` would push it down by the header
       height and shove the page. Department megas stay position:fixed. */
    if (brands) top -= root.getBoundingClientRect().top;
    panel.style.top = Math.round(top) + 'px';
  }

  function open(item) {
    if (openItem === item) return;
    closeAll();
    var panel = panelOf(item);
    var trigger = triggerOf(item);
    if (panel) panel.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    openItem = item;
    if (scrim) scrim.hidden = false;
    root.classList.add('has-open-panel');
    placePanel(item);
    var searchResults = root.querySelector('[data-bcb-search-results]');
    if (searchResults) searchResults.hidden = true;
    item.dispatchEvent(new CustomEvent('bcb:panelopen'));

    /* On a phone the chip that was tapped is often half off-screen, so the
       panel would open attached to something the shopper cannot see. */
    if (!canHover && item.scrollIntoView && !item.hasAttribute('data-bcb-brands')) {
      item.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  items.forEach(function (item) {
    var trigger = triggerOf(item);
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      /* Phone department chips go to the collection. The mega is a desktop
         hover surface; on a phone it was an empty dimmed sheet. */
      if (isPhoneNav() && !item.hasAttribute('data-bcb-brands')) return;
      event.preventDefault();
      if (openItem === item) close(item);
      else open(item);
    });

    if (canHover && !item.hasAttribute('data-bcb-brands')) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { open(item); }, 40);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { close(item); }, 80);
      });
    }

    /* Tabbing out of the last link in a panel should close it, otherwise the
       panel stays open over the page while focus is somewhere else entirely. */
    item.addEventListener('focusout', function (event) {
      if (!ownsEvent(item, event.relatedTarget)) close(item);
    });

    var panel = panelOf(item);
    if (panel && panel.parentElement !== item) {
      panel.addEventListener('focusout', function (event) {
        if (openItem === item && !ownsEvent(item, event.relatedTarget)) close(item);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !openItem) return;
    var trigger = triggerOf(openItem);
    close(openItem);
    if (trigger) trigger.focus();
  });

  window.addEventListener('scroll', function () {
    if (openItem) placePanel(openItem);
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (openItem) placePanel(openItem);
  });

  /* A focused department that has scrolled out of the rail must come back
     into view, otherwise keyboard users tab into a control they cannot see. */
  var navScroll = root.querySelector('[data-bcb-nav-scroll]');
  if (navScroll) {
    navScroll.addEventListener('focusin', function (event) {
      var item = event.target.closest('.bcb-nav__item');
      if (!item || !navScroll.contains(item) || !item.scrollIntoView) return;
      item.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  document.addEventListener('click', function (event) {
    if (openItem && !ownsEvent(openItem, event.target)) closeAll();
  });

  if (scrim) scrim.addEventListener('click', closeAll);

  /* ------------------------------------------ department product half */

  /* The product half of a department panel is fetched, not drawn with the page:
     rendering it for every department on every page view made the header the
     slowest part of the page (see the section's comment). The department's own
     best sellers and the subcategory previews come from the same
     collection.menu fragment, through one cache, so the two can never race or
     ask for the same collection twice.

     Hovering a subcategory swaps the products beside it, so the panel answers
     "what is in here?" before the shopper commits to a click. Pointer devices
     only. Below 1024px the CSS hides the product half altogether (products would
     push the subcategory a shopper is reaching for below the fold), so nothing
     is fetched there either. */
  var wideNav = window.matchMedia('(min-width: 1024px)');
  var fragments = new Map();
  var pending = new Map();

  /* Resolves to the fragment ('' for an empty collection) or null on failure.
     Failures are not cached, so the next open tries again. */
  function fragment(handle) {
    if (fragments.has(handle)) return Promise.resolve(fragments.get(handle));
    if (pending.has(handle)) return pending.get(handle);
    /* Through the locale root, so a /fr/ page gets French cards and prices. */
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var request = fetch(base + 'collections/' + encodeURIComponent(handle) + '?view=menu', {
      headers: { 'X-Requested-With': 'fetch' }
    })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var trimmed = html.trim();
        fragments.set(handle, trimmed);
        return trimmed;
      })
      .catch(function () { return null; })
      .then(function (html) {
        pending.delete(handle);
        return html;
      });
    pending.set(handle, request);
    return request;
  }

  items.forEach(function (item) {
    var feature = item.querySelector('[data-bcb-feature]');
    if (!feature) return;

    var feed = feature.getAttribute('data-bcb-feed');
    var links = canHover
      ? Array.prototype.slice.call(item.querySelectorAll('[data-bcb-peek]'))
      : [];
    /* The department's default view. Inline markup where the server drew it
       (the Ads landing page); otherwise null until the feed arrives. */
    var fallback = feed ? null : feature.innerHTML;
    var shown = feature.innerHTML;

    /* The feed fragment is the collection's own view; as the default it takes
       the section's heading, link text and product count instead. A template
       keeps the images inert while it is edited. */
    function asDefault(html) {
      var box = document.createElement('template');
      box.innerHTML = html;
      var count = parseInt(feature.getAttribute('data-count'), 10);
      var cards = box.content.querySelectorAll('.bcb-mega__products > li');
      for (var i = count; i < cards.length; i += 1) cards[i].remove();
      var label = feature.getAttribute('data-label');
      var eyebrow = box.content.querySelector('.bcb-mega__eyebrow');
      if (label && eyebrow) eyebrow.textContent = label;
      var allLabel = feature.getAttribute('data-all-label');
      var all = box.content.querySelector('.bcb-mega__all');
      if (allLabel && all && all.firstChild && all.firstChild.nodeType === 3) {
        all.firstChild.nodeValue = allLabel + ' ';
      }
      return box.innerHTML;
    }

    /* Draws whatever the current state calls for, so responses may land in any
       order: the hovered subcategory once it has products, the department
       default otherwise, and nothing rather than another subcategory's products
       when there is no default either. While the hovered one is still on its
       way the screen is left alone rather than flashing back to the default. */
    function paint() {
      var current = feature.dataset.current;
      var html = current ? fragments.get(current) : undefined;
      if (current && html === undefined && pending.has(current)) return;
      if (!html) html = fallback || '';
      if (html === shown) return;
      feature.innerHTML = html;
      shown = html;
    }

    function loadDefault() {
      if (!feed || fallback !== null || !wideNav.matches) return;
      fragment(feed).then(function (html) {
        if (html && fallback === null) fallback = asDefault(html);
        paint();
      });
    }

    item.addEventListener('bcb:panelopen', function () {
      loadDefault();
      links.forEach(function (link) {
        fragment(link.getAttribute('data-bcb-peek')).then(paint);
      });
    });

    links.forEach(function (link) {
      var handle = link.getAttribute('data-bcb-peek');

      function request() {
        links.forEach(function (l) { l.classList.toggle('is-peeking', l === link); });
        feature.dataset.current = handle;
        var arriving = fragment(handle);
        paint();
        arriving.then(paint);
      }

      link.addEventListener('mouseenter', request);
      link.addEventListener('focus', request);
    });

    /* Closing resets the panel so the next open starts from the department's
       own best sellers rather than whatever was last hovered. */
    item.addEventListener('bcb:panelclose', function () {
      delete feature.dataset.current;
      links.forEach(function (l) { l.classList.remove('is-peeking'); });
      shown = fallback || '';
      feature.innerHTML = shown;
    });
  });

  /* ---------------------------------------------------- brand collages */

  /* The page carries the brands as wordmark tiles; the collages (wordmark plus
     three products each) replace them the first time the panel opens. Fetched
     for the current path so the Ads landing page's brand filter still applies.
     On failure the wordmark tiles simply stay. */
  var brandItem = root.querySelector('[data-bcb-brands]');
  var brandState = '';
  if (brandItem) {
    brandItem.addEventListener('bcb:panelopen', function () {
      var panel = panelOf(brandItem);
      var grid = panel && panel.querySelector('.bcb-brand-grid');
      if (!grid || brandState) return;
      brandState = 'loading';
      fetch(window.location.pathname + '?section_id=bcb-brand-panel', {
        headers: { 'X-Requested-With': 'fetch' }
      })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var box = document.createElement('template');
          box.innerHTML = html;
          var collages = box.content.querySelector('.bcb-brand-grid');
          if (!collages || !collages.children.length) return Promise.reject('empty');
          /* Keep keyboard focus on the same brand across the swap. Focus moves
             before the old list goes: removing a focused link would fire the
             panel's focusout and close it under the shopper. */
          var active = document.activeElement;
          var focused = grid.contains(active) ? active.getAttribute('href') : null;
          grid.parentNode.insertBefore(collages, grid);
          if (focused) {
            var again = collages.querySelector('a[href="' + CSS.escape(focused) + '"]') ||
              collages.querySelector('a');
            if (again) again.focus();
          }
          grid.remove();
          brandState = 'done';
        })
        .catch(function () { brandState = ''; });
    });
  }

  /* ------------------------------------------------------- sticky behaviour */

  if (root.classList.contains('bcb-header--sticky')) {
    var lastY = 0;
    var ticking = false;
    var desktopNav = window.matchMedia('(min-width: 1024px)');
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var stuck = y > 8;
      /* Hide-on-scroll-down is desktop-only. On a phone the department bar
         is the catalogue, and toggling display:none mid-scroll changes the
         sticky height so the page jumps back toward the header. */
      var condensed = false;
      if (!openItem && desktopNav.matches) {
        condensed = y > 220 && y > lastY + 12;
      }
      var heightDirty =
        root.classList.contains('is-stuck') !== stuck ||
        root.classList.contains('is-condensed') !== condensed;
      root.classList.toggle('is-stuck', stuck);
      root.classList.toggle('is-condensed', condensed);
      lastY = y;
      ticking = false;
      if (heightDirty) setHeaderHeight();
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });
  }

  /* ------------------------------------------------------- mobile drawer */

  var drawer = document.querySelector('[data-bcb-drawer]');
  var drawerOpen = root.querySelector('[data-bcb-drawer-open]');
  var drawerClose = document.querySelector('[data-bcb-drawer-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    if (drawerOpen) drawerOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (scrim) {
      scrim.hidden = !open && !openItem;
      scrim.classList.toggle('is-drawer', open);
    }
    document.body.style.overflow = open ? 'hidden' : '';
    document.documentElement.classList.toggle('bcb-drawer-on', open);
    if (open) {
      closeAll();
      if (drawerClose) drawerClose.focus();
    } else if (drawerOpen) {
      drawerOpen.focus();
    }
  }

  if (drawerOpen) {
    drawerOpen.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setDrawer(drawer.hidden);
    });
  }
  if (drawerClose) drawerClose.addEventListener('click', function () { setDrawer(false); });
  if (scrim) {
    scrim.addEventListener('click', function () { setDrawer(false); });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && !drawer.hidden) setDrawer(false);
  });

  if (drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-bcb-localize]'), function (el) {
      el.addEventListener('change', function () {
        if (el.form) el.form.submit();
      });
    });
  }

  /* ----------------------------------------------------- predictive search */

  var search = root.querySelector('[data-bcb-search]');
  if (!search) return;

  var input = search.querySelector('[data-bcb-search-input]');
  var results = search.querySelector('[data-bcb-search-results]');
  var clear = search.querySelector('[data-bcb-search-clear]');
  if (!input || !results) return;

  var timer = null;
  var controller = null;
  var lastQuery = '';

  function hideResults() {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  /* The suggestion endpoint returns price as a decimal string in shop currency
     ("12.99"), not the integer cents the cart and section APIs use, so the two
     have to be told apart before formatting or every price comes out 100x off. */
  function money(raw) {
    var amount = typeof raw === 'number'
      ? raw / 100
      : parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
    if (!isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(payload, query) {
    var products = (payload.resources && payload.resources.results && payload.resources.results.products) || [];
    var collections = (payload.resources && payload.resources.results && payload.resources.results.collections) || [];

    if (!products.length && !collections.length) {
      results.innerHTML =
        '<p class="bcb-search__empty">No matches for &ldquo;' + escapeHtml(query) + '&rdquo;. ' +
        'Try a brand name or an ingredient.</p>';
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    var html = '';

    if (collections.length) {
      html += '<p class="bcb-search__group">Categories</p><ul class="bcb-search__cats" role="list">';
      collections.slice(0, 4).forEach(function (c) {
        html += '<li><a role="option" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
      });
      html += '</ul>';
    }

    if (products.length) {
      html += '<p class="bcb-search__group">Products</p><ul class="bcb-search__items" role="list">';
      products.slice(0, 6).forEach(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + escapeHtml(p.featured_image.url) + '&width=120" alt="" width="60" height="60" loading="lazy">'
          : '';
        var price = p.price === undefined || p.price === null ? '' : money(p.price);
        html +=
          '<li><a class="bcb-search__item" role="option" href="' + escapeHtml(p.url) + '">' +
          '<span class="bcb-search__thumb">' + img + '</span>' +
          '<span class="bcb-search__meta">' +
          (p.vendor ? '<span class="bcb-search__brand">' + escapeHtml(p.vendor) + '</span>' : '') +
          '<span class="bcb-search__name">' + escapeHtml(p.title) + '</span>' +
          (price ? '<span class="bcb-search__price">' + price + '</span>' : '') +
          '</span></a></li>';
      });
      html += '</ul>';
    }

    html +=
      '<a class="bcb-search__more" href="/search?q=' + encodeURIComponent(query) + '">' +
      'See all results for &ldquo;' + escapeHtml(query) + '&rdquo;</a>';

    results.innerHTML = html;
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function query(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url =
      '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (payload) { render(payload, term); })
      .catch(function () { /* an aborted or failed suggestion must never block the form */ });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    if (clear) clear.hidden = term.length === 0;
    clearTimeout(timer);

    /* Two characters is too short to be meaningful across 82,000 products and
       would return near-random matches. */
    if (term.length < 3) {
      hideResults();
      return;
    }
    if (term === lastQuery) return;
    lastQuery = term;
    timer = setTimeout(function () { query(term); }, 220);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 3 && results.innerHTML) {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  });

  if (clear) {
    clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      lastQuery = '';
      hideResults();
      input.focus();
    });
  }

  document.addEventListener('click', function (event) {
    if (!search.contains(event.target)) hideResults();
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      hideResults();
      return;
    }
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    var options = Array.prototype.slice.call(results.querySelectorAll('a'));
    if (!options.length) return;
    event.preventDefault();
    var index = options.indexOf(document.activeElement);
    var next = event.key === 'ArrowDown' ? index + 1 : index - 1;
    if (next < 0) {
      input.focus();
      return;
    }
    (options[next] || options[0]).focus();
  });
})();

(function () {
  'use strict';

  var util = document.querySelector('[data-bcb-util]');
  var ship = document.querySelector('[data-bcb-ship]');
  var bubbles = document.querySelectorAll('[data-bcb-cart-count]');
  if (!ship && !bubbles.length) return;

  var emptyEl = ship && ship.querySelector('[data-bcb-ship-empty]');
  var remainEl = ship && ship.querySelector('[data-bcb-ship-remain]');
  var doneEl = ship && ship.querySelector('[data-bcb-ship-done]');
  var amountEl = ship && ship.querySelector('[data-bcb-ship-amount]');
  var progressEl = ship && ship.querySelector('[data-bcb-ship-progress]');
  var iconEl = ship && ship.querySelector('[data-bcb-ship-icon]');
  var limit = Number(ship && ship.getAttribute('data-limit')) || 50;
  var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
  var limitCents = limit * 100 * rate;
  var truckIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="7" width="15" height="10" rx="1.5"/><path d="M16 11h4l3 3v3h-7V11Z"/><circle cx="6.5" cy="18.5" r="1.5"/><circle cx="18.5" cy="18.5" r="1.5"/></svg>';
  var checkIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var lastKey = '';
  var timer = null;
  var fetching = false;

  function formatMoney(cents) {
    var formatted;
    if (window.themeVendor && themeVendor.themeCurrency && window.theme) {
      formatted = themeVendor.themeCurrency.formatMoney(Math.max(cents, 0), theme.moneyFormat);
      if (theme.settings && theme.settings.currency_code_enable && theme.currencyCode) {
        formatted += ' ' + theme.currencyCode;
      }
      return formatted.replace('.00', '');
    }
    return '$' + Math.max(Math.ceil(cents / 100), 0);
  }

  function renderShip(cart) {
    if (!util || !ship) return;
    var total = Number(cart.total_price) || 0;
    var count = Number(cart.item_count) || 0;
    var empty = count === 0;
    var unlocked = !empty && total >= limitCents;
    var remaining = Math.max(limitCents - total, 0);
    var percent = limitCents > 0 ? Math.min(100, (total / limitCents) * 100) : 0;

    util.classList.toggle('is-ship-unlocked', unlocked);
    if (emptyEl) emptyEl.hidden = !empty;
    if (remainEl) remainEl.hidden = empty || unlocked;
    if (doneEl) doneEl.hidden = !unlocked;
    amountEl = ship.querySelector('[data-bcb-ship-amount]');
    if (amountEl) amountEl.textContent = formatMoney(remaining);
    if (progressEl) progressEl.style.setProperty('--ship-pct', percent + '%');
    if (iconEl) iconEl.innerHTML = unlocked ? checkIcon : truckIcon;
  }

  function renderBubbles(cart) {
    if (!bubbles.length) return;
    var n = Math.max(0, parseInt(cart.item_count, 10) || 0);
    var label = n > 99 ? '99+' : String(n);
    var empty = n === 0;
    bubbles.forEach(function (el) {
      el.textContent = label;
      el.classList.toggle('is-empty', empty);
      el.setAttribute('aria-hidden', empty ? 'true' : 'false');
    });
  }

  function apply(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    var key = String(cart.item_count) + ':' + String(cart.total_price);
    if (key === lastKey) return;
    lastKey = key;
    renderShip(cart);
    renderBubbles(cart);
  }

  function gsCart() {
    try {
      if (window.gsCartDrawerCore && typeof gsCartDrawerCore.getCart === 'function') {
        return gsCartDrawerCore.getCart();
      }
    } catch (e) {}
    return null;
  }

  function refresh() {
    var live = gsCart();
    if (live && typeof live.item_count !== 'undefined') apply(live);

    if (fetching) return;
    fetching = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root.replace(/\/?$/, '/') + 'cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(apply)
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  function schedule(event) {
    var detail = event && event.detail;
    if (detail && detail.cart && typeof detail.cart.item_count !== 'undefined') {
      apply(detail.cart);
    }
    clearTimeout(timer);
    timer = setTimeout(refresh, 60);
  }

  [
    'theme:cart:change',
    'theme:cart:reload',
    'cart:updated',
    'cart_changed_gs',
    'cart_discount_changed_gs',
    'gsCartTotalUpdated',
    'gs:incentives:updated'
  ].forEach(function (name) {
    window.addEventListener(name, schedule);
    document.addEventListener(name, schedule);
  });

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(function () { schedule(); }).catch(function () { schedule(); });
      return;
    }
    schedule();
  });

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return nativeFetch.apply(this, arguments).then(function (res) {
        if (isCartWrite(url)) schedule();
        return res;
      });
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._bcbCartUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (isCartWrite(this._bcbCartUrl)) {
        this.addEventListener('load', function () { schedule(); });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  if (typeof PerformanceObserver === 'function') {
    try {
      var observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (isCartWrite(entry.name)) schedule();
        });
      });
      observer.observe({ type: 'resource', buffered: true });
    } catch (e) {}
  }

  refresh();
})();
